import React, { useEffect, useState } from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import { Tooltip } from '@amzn/storm-ui';
import {
  Wrapper,
  CellText,
  MultiLineContainer,
  LineText,
  TooltipMessage,
} from './SlotNamesCellRenderer.styles';

const TooltipCellRenderer: React.FC<ICellRendererParams> = ({ value, eParentOfValue }) => {
  const displayValue = value != null ? String(value) : '-';
  const [cellWidth, setCellWidth] = useState<number | undefined>(undefined);

  useEffect(() => {
    if (!eParentOfValue || displayValue === '-') return;

    const updateWidth = () => {
      const padding = 20;
      setCellWidth(eParentOfValue.clientWidth - padding);
    };

    updateWidth();

    const observer = new ResizeObserver(updateWidth);
    observer.observe(eParentOfValue);
    return () => observer.disconnect();
  }, [eParentOfValue, displayValue]);

  if (displayValue === '-') return <CellText>{displayValue}</CellText>;

  const lines = displayValue.split('\n');

  const content = (
    <Wrapper style={{ maxWidth: cellWidth }}>
      {lines.length > 1 ? (
        <MultiLineContainer>
          {lines.map((line, idx) => (
            <LineText key={idx}>{line}</LineText>
          ))}
        </MultiLineContainer>
      ) : (
        <CellText>{displayValue}</CellText>
      )}
    </Wrapper>
  );

  return (
    <Tooltip
      message={<TooltipMessage>{displayValue}</TooltipMessage>}
      position="top"
      variant="default"
      withCloseButton={false}
      transitionDuration={0}
      trigger={content}
    />
  );
};

export default TooltipCellRenderer;
